module.exports = __webpack_public_path__ + "img/tu02.146e5911.jpg";